import { useAuth } from "../../context/authContext";
import { Menu } from "../../components/common/menu";
import ScrollToTop from "./ScrollToTop";

const Layout = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div>
      {isAuthenticated && <Menu />}
      {isAuthenticated && <ScrollToTop />}
    </div>
  );
};

export default Layout;
